import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=73a7e6dc&"
import script from "./Shell.vue?vue&type=script&lang=js&"
export * from "./Shell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports